/* ==========================================================================
   BodenWerk – Warenkorb rechnet ohne "Aktualisieren"-Klick neu

   Mengenaenderung -> /cart/change.js -> Warenkorb- und Header-Section ueber
   die Section Rendering API neu holen und austauschen. Ohne JavaScript bleibt
   der Knopf "Aktualisieren" stehen und alles laeuft wie bisher ueber das
   Formular. Schlaegt der Abruf fehl, schickt das Skript das Formular regulaer
   ab, damit keine Aenderung verloren geht.
   ========================================================================== */
(function () {
  'use strict';

  var WARTEN_MS = 600; // Tippen abwarten, bevor neu gerechnet wird
  var timer = null;
  var flaeche = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  function wurzel() {
    return document.querySelector('[data-bw-cart-section]');
  }

  function knopfVerstecken() {
    var w = wurzel();
    if (!w) return;
    var knopf = w.querySelector('button[name="update"]');
    if (knopf) knopf.hidden = true;
  }

  function headerSectionId() {
    var bubble = document.getElementById('cart-icon-bubble');
    var sec = bubble && bubble.closest('.shopify-section');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }

  function regulaerAbschicken(w) {
    var form = w.querySelector('form');
    var knopf = w.querySelector('button[name="update"]');
    if (form && form.requestSubmit && knopf) form.requestSubmit(knopf);
    else if (form) form.submit();
  }

  function aktualisieren(feld) {
    var w = wurzel();
    if (!w) return;
    var menge = parseInt(feld.value, 10);
    if (isNaN(menge) || menge < 0) return;
    var zeile = parseInt(feld.getAttribute('data-bw-zeile'), 10);
    var cartId = w.getAttribute('data-bw-cart-section');
    var headerId = headerSectionId();
    var sections = [cartId].concat(headerId ? [headerId] : []);

    // Line-Item-Properties aus dem m²-Rechner passen nach einer
    // Mengenaenderung nicht mehr: gelieferte Flaeche neu rechnen, die alte
    // Flaechenberechnung (Gewuenschte Flaeche, Verschnitt) entfernen.
    var props = null;
    var paket = parseFloat(feld.getAttribute('data-bw-paketflaeche')) || 0;
    try { props = JSON.parse(feld.getAttribute('data-bw-props') || 'null'); } catch (e) { props = null; }
    // Liquid liefert item.properties als Liste von [Name, Wert]-Paaren
    if (Array.isArray(props)) {
      var obj = {};
      props.forEach(function (paar) { if (paar && paar.length === 2) obj[paar[0]] = paar[1]; });
      props = obj;
    }
    var anfrage = { line: zeile, quantity: menge, sections: sections, sections_url: window.location.pathname };
    if (props && paket > 0 && menge > 0 && props['Gelieferte Fläche'] !== undefined) {
      var neu = {};
      Object.keys(props).forEach(function (k) {
        if (k !== 'Gewünschte Fläche' && k !== 'Verschnitt') neu[k] = props[k];
      });
      neu['Gelieferte Fläche'] = flaeche.format(menge * paket) + ' m²';
      anfrage.properties = neu;
    }

    w.setAttribute('aria-busy', 'true');
    w.classList.add('bw-cartpage--laedt');

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(anfrage)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change ' + r.status);
        return r.json();
      })
      .then(function (daten) {
        var html = daten.sections && daten.sections[cartId];
        if (!html) throw new Error('keine Section');
        var neu = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bw-cart-section]');
        if (!neu) throw new Error('Section leer');
        w.replaceWith(neu);

        if (headerId && daten.sections[headerId]) {
          var kopf = new DOMParser().parseFromString(daten.sections[headerId], 'text/html');
          var alt = document.getElementById('cart-icon-bubble');
          var frisch = kopf.getElementById('cart-icon-bubble');
          if (alt && frisch) alt.innerHTML = frisch.innerHTML;
        }

        knopfVerstecken();
        if (window.bwVersand && window.bwVersand.statischZeichnen) window.bwVersand.statischZeichnen();

        // Fokus zurueck auf dieselbe Zeile, falls es sie noch gibt
        var wieder = neu.querySelector('[data-bw-zeile="' + zeile + '"]');
        if (wieder && document.activeElement === document.body) wieder.focus();
      })
      .catch(function () {
        w.removeAttribute('aria-busy');
        w.classList.remove('bw-cartpage--laedt');
        regulaerAbschicken(w);
      });
  }

  document.addEventListener('input', function (e) {
    var feld = e.target.closest && e.target.closest('[data-bw-zeile]');
    if (!feld) return;
    clearTimeout(timer);
    timer = setTimeout(function () { aktualisieren(feld); }, WARTEN_MS);
  });

  // Enter im Mengenfeld: sofort neu rechnen statt Formular abzuschicken
  document.addEventListener('keydown', function (e) {
    var feld = e.target.closest && e.target.closest('[data-bw-zeile]');
    if (!feld || e.key !== 'Enter') return;
    e.preventDefault();
    clearTimeout(timer);
    aktualisieren(feld);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', knopfVerstecken);
  else knopfVerstecken();
})();
